import { TUSCANY_UNIVERSITIES } from '../constants';

const sparqlFilterTuscanyUniversities = (orgObj) => {
  return ' FILTER( ' + 
  TUSCANY_UNIVERSITIES.map( (org, index) => {
    return orgObj + '=' + org.id + (index < TUSCANY_UNIVERSITIES.length-1 ? '||' : ' ');
  }).join(' ') + ' ) . ';
}

export const queries = {
  // spinoffs

  atecoData : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
  PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
  PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
  PREFIX dce: <http://purl.org/dc/elements/1.1/#>
  SELECT
      ?name 
      ?foundationDate
      ?founderCapital
      ?liquidationYear
      ?cessationYear
      ?innovative
      ?founderName
      ?atecoName
      ?active
  WHERE {
      ?spinoff a :Spinoff .
      ?spinoff :facility ?facility .
  	  ?facility :regionName ?region .
  	  FILTER (?region = "Toscana") 
      ?spinoff :extendedName ?name .
      ?spinoff :foundationDate ?foundationDate .
      optional { ?spinoff :founderCapital ?founderCapital } .
      optional { ?spinoff :liquidationYear ?liquidationYear }.
      optional { ?spinoff :cessationYear ?cessationYear } .  
      optional { ?spinoff :status ?status } .
      optional { ?spinoff :active ?active } .
      optional {
          ?spinoff :ateco ?ateco .
          ?ateco :extendedName ?atecoName
      }
      optional {
          ?spinoff :foundedBy ?founder . 
          ?founder :extendedName ?founderName
        }
      optional { ?spinoff :innovative ?innovative }
  }`,

  atecoSectorsCount : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    SELECT ?name (count(?name) as ?count)
    WHERE {
      ?spinoff a :Spinoff . 
      ?spinoff :facility ?facility .
  	  ?facility :regionName ?region .
  	  FILTER (?region = "Toscana") 
        ?spinoff :ateco ?ateco .
      ?ateco :extendedName ?name
    }
    group by ?name
    order by desc(?count)`
    ,

  // erasmus+
  projectsByTopic : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
    SELECT ?name (COUNT(DISTINCT ?projId) AS ?count)
    WHERE {
      SELECT  distinct ?projId ?name
      WHERE {
        ?proj a :ErasmusPlus-Project .
        ?proj :identifier ?projId .
        ?proj :erasmusplusKeyAction ?action .
        ?action :extendedName ?actionname .
        FILTER (?actionname = "Learning Mobility of Individuals") .
        
        ?proj :erasmusplusParticipant ?participant .    
        ?participant :nuts2 ?nuts2 .
        ?nuts2 :identifier ?nuts2Code .
        FILTER (?nuts2Code = "ITI1") .

        ?proj :title ?projTitle .
        ?proj :erasmusplusTopic ?topic . 
        ?topic :extendedName ?name .
      }
    }
    group by ?name
    order by desc(?count)`
    ,
  participantsByOrgType : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
    SELECT ?name (COUNT(DISTINCT ?participantname) AS ?count)
    WHERE {
      SELECT  distinct ?participantname ?name
      WHERE {
        ?proj a :ErasmusPlus-Project .
        ?proj :identifier ?projId .
        ?proj :erasmusplusKeyAction ?action .
        ?action :extendedName ?actionname .
        FILTER (?actionname = "Learning Mobility of Individuals") .
        
        ?proj :erasmusplusParticipant ?participant .
        ?participant :extendedName ?participantname .
        ?participant :erasmusplusOrgTypeName ?name .
        ?participant :nuts2 ?nuts2 .
        ?nuts2 :identifier ?nuts2Code .
        FILTER (?nuts2Code = "ITI1")
      }
    }
    group by ?name
    order by desc(?count)`,
  // gets all projects and all collaborators, differentiating between
  // participants from Tuscany region and the rest
  projectsAndParticipants : (topic) => `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
  SELECT distinct
  
      ?title  
      ?topicname
      ?projId
      ?partT
      ?latT
      ?lonT
      ?cityT
      ?orgTypeT
      ?nuts3T
  
      ?part
      ?lat
      ?lon
      ?city
     
  WHERE {
      ?proj a :ErasmusPlus-Project .
      ?proj :title ?title .
      ?proj :identifier ?projId .
      ?proj :erasmusplusKeyAction ?action .
      ?action :extendedName ?actionname .
      FILTER (?actionname = "Learning Mobility of Individuals") .
  
      ?proj :erasmusplusTopic ?topic .
      ?topic :extendedName ?topicname .
      FILTER (?topicname = "` + topic + `") .
  
      ?proj :erasmusplusParticipant ?partToscana .
      ?partToscana :extendedName ?partT .
      ?partToscana :nuts2 ?nuts2Toscana .
      ?nuts2Toscana :identifier ?nuts2ToscanaCode .
      FILTER (?nuts2ToscanaCode = "ITI1") .
      ?partToscana :nuts3 ?nuts3Toscana .
      ?nuts3Toscana :identifier ?nuts3T .
      ?partToscana :geoLat ?latT .
      ?partToscana :geoLong ?lonT .
      ?partToscana :cityName ?cityT .
  
      ?proj :erasmusplusParticipant ?partNoToscana.
      ?partNoToscana :nuts2 ?nuts2 .
      ?partNoToscana :extendedName ?part .
      ?nuts2 :identifier ?nuts2Code .
      FILTER (?nuts2Code != "ITI1")
      ?partNoToscana :geoLat ?lat .
      ?partNoToscana :geoLong ?lon .
      ?partNoToscana :cityName ?city .
  
      optional { ?partToscana :erasmusplusOrgTypeName ?orgTypeT . }
  }`,

  // Get the courses by filtering as "DOTTORATO DI RECERCA"

  postgraduatesIscrittiPHD : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX dce: <http://purl.org/dc/elements/1.1/#>
      SELECT 
        ?year 
        ?female 
        ?male 
        ?foreignFemale 
        ?foreignMale 
        ?courseName 
        ?organizationName 
      WHERE {
        ?entUstat a :USTAT-Postgraduate-Iscritti .
        ?entUstat :organization ?entOrganization .
        ?entOrganization :extendedName ?organizationName . 
        ?entOrganization :unicsId ?organizationId . ` + 
        sparqlFilterTuscanyUniversities('?organizationId') + 
        `?entUstat :academicYear ?year .
        optional { ?entUstat :totalFemale ?female } .
        optional { ?entUstat :totalForeignFemale ?foreignFemale } .
        optional { ?entUstat :totalMale ?male } .
        optional { ?entUstat :totalForeignMale ?foreignMale } .
        ?entUstat :ustatPostgraduateCourse ?entCourse .
        ?entCourse :extendedName ?courseName .
        ?entCourse :ustatCourseTypeName ?courseType .
        FILTER (?courseType = "DOTTORATO DI RICERCA")
    }`,

  postgraduatesIscrittiMaster : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX dce: <http://purl.org/dc/elements/1.1/#>
      SELECT 
        ?year 
        ?female 
        ?male 
        ?foreignFemale 
        ?foreignMale 
        ?courseName 
        ?organizationName 
      WHERE {
        ?entUstat a :USTAT-Postgraduate-Iscritti .
        ?entUstat :organization ?entOrganization .
        ?entOrganization :extendedName ?organizationName . 
        ?entOrganization :unicsId ?organizationId . ` + 
        sparqlFilterTuscanyUniversities('?organizationId') + 
        `?entUstat :academicYear ?year .
        optional { ?entUstat :totalFemale ?female } .
        optional { ?entUstat :totalForeignFemale ?foreignFemale } .
        optional { ?entUstat :totalMale ?male } .
        optional { ?entUstat :totalForeignMale ?foreignMale } .
        ?entUstat :ustatPostgraduateCourse ?entCourse .
        ?entCourse :extendedName ?courseName .
        ?entCourse :ustatCourseTypeName ?courseType .
        FILTER (?courseType = "Master Universitario di I livello" || ?courseType = "Master Universitario di II livello")
    }`,

    postgraduatesDiplomatiPHD : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX dce: <http://purl.org/dc/elements/1.1/#>
      SELECT 
        ?year 
        ?female 
        ?male 
        ?foreignFemale 
        ?foreignMale 
        ?courseName 
        ?organizationName 
      WHERE {
        ?entUstat a :USTAT-Postgraduate-Diplomati .
        ?entUstat :organization ?entOrganization .
        ?entOrganization :extendedName ?organizationName . 
        ?entOrganization :unicsId ?organizationId . ` + 
        sparqlFilterTuscanyUniversities('?organizationId') + 
        `?entUstat :year ?year .
        optional { ?entUstat :totalFemale ?female } .
        optional { ?entUstat :totalForeignFemale ?foreignFemale } .
        optional { ?entUstat :totalMale ?male } .
        optional { ?entUstat :totalForeignMale ?foreignMale } .
        ?entUstat :ustatPostgraduateCourse ?entCourse .
        ?entCourse :extendedName ?courseName .
        ?entCourse :ustatCourseTypeName ?courseType .
        FILTER (?courseType = "DOTTORATO DI RICERCA")
    }`,

    postgraduatesDiplomatiMaster : `PREFIX : <http://www.semanticweb.org/ontologies/2016/4/untitled-ontology-69#>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX dce: <http://purl.org/dc/elements/1.1/#>
      SELECT 
        ?year 
        ?female 
        ?male 
        ?foreignFemale 
        ?foreignMale 
        ?courseName 
        ?organizationName 
      WHERE {
        ?entUstat a :USTAT-Postgraduate-Diplomati .
        ?entUstat :organization ?entOrganization .
        ?entOrganization :extendedName ?organizationName . 
        ?entOrganization :unicsId ?organizationId . ` + 
        sparqlFilterTuscanyUniversities('?organizationId') + 
        `?entUstat :year ?year .
        optional { ?entUstat :totalFemale ?female } .
        optional { ?entUstat :totalForeignFemale ?foreignFemale } .
        optional { ?entUstat :totalMale ?male } .
        optional { ?entUstat :totalForeignMale ?foreignMale } .
        ?entUstat :ustatPostgraduateCourse ?entCourse .
        ?entCourse :extendedName ?courseName .
        ?entCourse :ustatCourseTypeName ?courseType .
        FILTER (?courseType = "Master Universitario di I livello" || ?courseType = "Master Universitario di II livello")
    }`
}
